<template>
    <div class="dashboard">
        <ul class="nav nav-tabs">
            <li role="presentation" :class="{ active: $route.name === 'RegistrationErrors' }">
                <router-link to="/support/errors">{{ $t('support.dashboard.tabs.errors') }}</router-link>
            </li>
            <li role="presentation" :class="{ active: $route.name === 'RegistrationPendings' }">
                <router-link to="/support/pending">{{ $t('support.dashboard.tabs.pendings') }}</router-link>
            </li>
            <li role="presentation" :class="{ active: $route.name === 'RegistrationInProgress' }">
                <router-link to="/support/inprogress">{{ $t('support.dashboard.tabs.inprogress') }}</router-link>
            </li>
            <li role="presentation" :class="{ active: $route.name === 'RegistrationDuplicates' }">
                <router-link to="/support/duplicates">{{ $t('support.dashboard.tabs.duplicates') }}</router-link>
            </li>
            <li role="presentation" :class="{ active: $route.name === 'RegistrationFinished' }">
                <router-link to="/support/finished">{{ $t('support.dashboard.tabs.finished') }}</router-link>
            </li>
            <li role="presentation" :class="{ active: $route.name === 'Usage' || $route.name === 'UsageDetails' }">
                <router-link to="/support/usage">{{ $t('support.dashboard.tabs.usage') }}</router-link>
            </li>
            <li
                role="presentation"
                :class="{ active: $route.name === 'EmailPreview' || $route.name === 'EmailPreviewDetails' }"
            >
                <router-link to="/support/email">{{ $t('support.dashboard.tabs.email') }}</router-link>
            </li>
        </ul>
        <router-view></router-view>
    </div>
</template>
<script>
export default {
    data: function() {
        return {};
    },
    computed: {},
    mounted() {},
    methods: {}
};
</script>
